(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid-custom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.getElementById('shopify-section-{{ section.id }}');
    if (!section) return;

    section.addEventListener('click', function (event) {
      const goProductBtn = event.target.closest('[data-collection-go-product]');
      if (goProductBtn && section.contains(goProductBtn)) {
        event.preventDefault();
        event.stopPropagation();
        const card = goProductBtn.closest('.collection-grid-custom__card');
        if (card && card.href) window.location.href = card.href;
        return;
      }

      const quickAddBtn = event.target.closest('[data-collection-quick-add]');
      if (quickAddBtn && section.contains(quickAddBtn)) {
        event.preventDefault();
        event.stopPropagation();
        const variantId = quickAddBtn.dataset.variantId;
        if (!variantId) return;

        const cart = document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(quickAddBtn);
        }

        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              console.error(response.description || response.message);
              return;
            }

            if (!cart) {
              window.location.href = window.routes.cart_url;
              return;
            }

            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'collection-grid-custom',
                productVariantId: variantId,
                cartData: response,
              });
            }

            cart.classList.remove('is-empty');
            cart.renderContents(response);
          })
          .catch(function (error) {
            console.error(error);
          });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (() => {
    const initializeDescriptions = (scope) => {
      scope.querySelectorAll('.collection-banner-carla--compact').forEach((banner) => {
        if (banner.dataset.descriptionInitialized) return;
        const description = banner.querySelector('[data-compact-description]');
        const button = banner.querySelector('[data-description-toggle]');
        if (!description || !button) return;
        banner.dataset.descriptionInitialized = 'true';
        const setExpanded = (expanded) => {
          banner.classList.toggle('is-description-expanded', expanded);
          button.setAttribute('aria-expanded', String(expanded));
        };
        button.addEventListener('click', () => {
          setExpanded(button.getAttribute('aria-expanded') !== 'true');
        });
        description.addEventListener('focusin', () => {
          setExpanded(true);
        });
        banner.classList.add('is-description-ready');
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeDescriptions(document), { once: true });
    } else {
      initializeDescriptions(document);
    }
    document.addEventListener('shopify:section:load', (event) => initializeDescriptions(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["similar-products-custom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.getElementById('shopify-section-{{ section.id }}');
    if (!section) return;

    section.addEventListener('click', function (event) {
      const goProductBtn = event.target.closest('[data-similar-go-product]');
      if (goProductBtn && section.contains(goProductBtn)) {
        event.preventDefault();
        event.stopPropagation();
        const card = goProductBtn.closest('.similar-products-custom__card');
        if (card && card.href) window.location.href = card.href;
        return;
      }

      const quickAddBtn = event.target.closest('[data-similar-quick-add]');
      if (quickAddBtn && section.contains(quickAddBtn)) {
        event.preventDefault();
        event.stopPropagation();
        const variantId = quickAddBtn.dataset.variantId;
        if (!variantId) return;

        const cart = document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(quickAddBtn);
        }

        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              console.error(response.description || response.message);
              return;
            }

            if (!cart) {
              window.location.href = window.routes.cart_url;
              return;
            }

            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'similar-products-custom',
                productVariantId: variantId,
                cartData: response,
              });
            }

            cart.classList.remove('is-empty');
            cart.renderContents(response);
          })
          .catch(function (error) {
            console.error(error);
          });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
